export default __webpack_public_path__ + "static/media/journeytray-greentree-flower.c96377a2.svg";